import React, { useEffect, useRef, useState } from "react";
import HumanVideo from "../assets/metrics/human-metric.mp4";
import "../styles/bodymetric.css";

export default function BodyMetricsCard({ data }) {
  const profile = data?.patient?.health_profile || {};

  // Extract API values safely
  const apiWeight = profile?.weight ?? null;
  const apiHeight = profile?.height ?? null;

  const [weight, setWeight] = useState(apiWeight);
  const [height, setHeight] = useState(apiHeight);

  const [bmi, setBmi] = useState(null);
  const [bmiStatus, setBmiStatus] = useState("Data Not Available");

  const videoRef = useRef(null);
  const containerRef = useRef(null);

/* -------------------------
   Sync API values to state
-------------------------- */
useEffect(() => {
  setWeight(apiWeight);
  setHeight(apiHeight);
}, [apiWeight, apiHeight]);

/* -------------------------
   BMI CALC
-------------------------- */
useEffect(() => {
  if (!weight || !height) {
    setBmi(null);
    setBmiStatus("Data Not Available");
    return;
  }

  const h = height / 100;
  const calculatedBmi = (weight / (h * h)).toFixed(1);
  setBmi(calculatedBmi);

  if (calculatedBmi < 18.5) setBmiStatus("Underweight");
  else if (calculatedBmi < 25) setBmiStatus("Normal");
  else if (calculatedBmi < 30) setBmiStatus("Overweight");
  else setBmiStatus("Obese");
}, [weight, height]);

  /* -------------------------
     JS Dynamic Video Scaling
  -------------------------- */
  useEffect(() => {
    function resizeVideo() {
      if (!containerRef.current || !videoRef.current) return;

      const containerWidth = containerRef.current.offsetWidth;

      // Maintain 9:16 aspect ratio (vertical)
      const calculatedHeight = containerWidth * (16 / 9);

      // Limit max height
      const finalHeight = Math.min(calculatedHeight, window.innerHeight * 0.75);

      videoRef.current.style.height = `${finalHeight}px`;
    }

    resizeVideo();
    window.addEventListener("resize", resizeVideo);
    return () => window.removeEventListener("resize", resizeVideo);
  }, []);

  return (
    <div className="bmc-card">

      {/* -------- ROW 1 -------- */}
      <div className="bmc-row">

        {/* Weight */}
        <div className="bmc-box small-box peach weight-height">
          <p className="bmc-title">Weight</p>
          <div className="bmc-ticks"></div>
          <h3 className="bmc-value">
            {weight ? weight : "Data Not Available"}{" "}
            <span>{weight ? "kg" : ""}</span>
          </h3>
        </div>

        {/* BMI */}
        <div className="bmc-box small-box">
          <p className="bmc-title">Body Mass Index</p>

          <div className="bmc-bmi-row">
            <h3 className="bmc-bmi">
              {bmi ? bmi : "Data Not Available"}
            </h3>

            <span
              className={`bmc-status ${
                bmiStatus === "Normal"
                  ? "normal"
                  : bmiStatus === "Underweight"
                  ? "underweight"
                  : bmiStatus === "Overweight"
                  ? "overweight"
                  : bmiStatus === "Obese"
                  ? "obese"
                  : "unknown"
              }`}
            >
              {bmiStatus}
            </span>
          </div>

          
        </div>
      </div>

      {/* -------- ROW 2 -------- */}
      <div className="bmc-row">

        {/* Height */}
        <div className="bmc-box small-box blue weight-height">
          <p className="bmc-title">Height</p>
          <div className="bmc-ticks"></div>
          <h3 className="bmc-value">
            {height ? height : "Data Not Available"}{" "}
            <span>{height ? "cm" : ""}</span>
          </h3>
        </div>

         {/* BMI */}
        <div className="bmc-box small-box">

          

          <div className="bmc-scale-values">
            <span>18.5</span>
            <span>24.9</span>
            <span>29.9</span>
          </div>

          <div className="bmc-scale">
            <span className="seg under"></span>
            <span className="seg normal"></span>
            <span className="seg over"></span>
          </div>
        </div>
      </div>

      {/* -------- VIDEO SECTION -------- */}
      <div className="bmc-video-box" ref={containerRef}>
        <video
          ref={videoRef}
          className="bmc-video"
          src={HumanVideo}
          autoPlay
          loop
          muted
          playsInline
        />
      </div>
    </div>
  );
}
